import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
  currentUser: any;
  // constructor(
  //   public datePipe: DatePipe
  // ) { }
  getToken(): string {

    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      this.currentUser = token;

      return token;
    }
    // else return false;

  }

  getRoles(): string {
    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).roles;
      console.log(token);
    }
    else return 'All';
  }

  getPermissions(): string {
   
    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).Permission;     
    }
    else return 'All';
   
  }

  getLoggedInUserProfileId(){
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).uid;
    }
   
    else return 0;
  }

  getLoggedInUserProfile(){
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token);
    }
   
    else return 0;
  }

  getLoggedInUserCompanyId(){
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).cid;
    }
   
    else return 0;
  }
  saveToken(token: String) {
    localStorage['VMS'] = token;
  }

  destroyToken() {
    localStorage.removeItem('VMS');
  }
  public urlBase64Decode(str: string): string {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0: { break; }
      case 2: { output += '=='; break; }
      case 3: { output += '='; break; }
      default: {
        throw 'Illegal base64url string!';
      }
    }
    return this.b64DecodeUnicode(output);
  }


  private b64decode(str: string): string {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output: string = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 == 1) {
      throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }

    for (
      // initialize result and counters
      let bc: number = 0, bs: any, buffer: any, idx: number = 0;
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  }

   private b64DecodeUnicode(str: any) {
    return decodeURIComponent(Array.prototype.map.call(this.b64decode(str), (c: any) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  public decodeToken(token: String): any {
    let parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }

    let decoded = this.urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }

    return JSON.parse(decoded);
  }

  public getTokenExpirationDate(token: String): Date {
    let decoded: any;
    decoded = this.decodeToken(token);
    if (!decoded.hasOwnProperty('exp')) {
      return null;
    }
   // console.log(decoded.exp);
    let date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  public isTokenExpired(token: String, offsetSeconds?: number): boolean {
    let date = this.getTokenExpirationDate(token);
    offsetSeconds = offsetSeconds || 0;

    if (date == null) {
      return false;
    }
    date.setSeconds(0,0);
    //console.log(date);
    return !(date.valueOf() >= (new Date().valueOf() + (offsetSeconds * 1000)));
  }

  checkSessionTimeout(): boolean {
    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      return true;
    }
    else return false;
  }
  isTokenAvailable(): boolean {
    const token: string = localStorage.getItem('VMS');

    if (token != null ) {
      return true;
    }
    else return false;
  }


  isMspUser(): boolean {
    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      var roleName = this.decodeToken(token).roles;
      if(roleName === "Super Admin" || roleName === "Admin" || roleName === "VMS Analyst"){
          return true;
      }
    }
    else return false;
  }

  isVendorUser(): boolean {
    const token: string = localStorage.getItem('VMS');

    if (token != null && !this.isTokenExpired(token)) {
      var roleName = this.decodeToken(token).roles;
      if(roleName === "Vendor Admin" || roleName === "Vendor Account" || roleName === "Vendor User"){
          return true;
      }
    }
    else return false;
  }


  getLoggedInUserName(){
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      return this.decodeToken(token).id;
    }
   
    else return 0;
  }
  
  gwtLoggedInUserProfileName(){
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      var fullName = this.decodeToken(token).firstname+' '+this.decodeToken(token).lastname;
      return fullName;
    }
   
    else return "";
  }

  getLoggedInUserFirstNameLastName() {
    const token: string = localStorage.getItem('VMS');
    if (token != null && !this.isTokenExpired(token)) {
      var nameDetails={
        firstName :this.decodeToken(token).firstname,
        lastName :this.decodeToken(token).lastname,
      }
      //var fullName = this.decodeToken(token).firstname+' '+this.decodeToken(token).lastname;
      return nameDetails;
    }
   
    else return "";
  }




}
